<script>
  import { onMount } from 'svelte';

  export let index;

  export let numberOfItems;

  onMount(() => {
    let prev = document.querySelector(`#carousel-item-${index - 1} .carousel-item-${index - 1}`);
    let current = document.querySelector(`#carousel-item-${index} .carousel-item-${index}`);
    let next = document.querySelector(`#carousel-item-${index + 1} .carousel-item-${index + 1}`);

    if (current?.parentElement) {
      if (prev?.firstElementChild) {
        current?.parentElement.insertBefore(prev.cloneNode(true), current);
      } else {
        let last = document.querySelector(
          `#carousel-item-${numberOfItems - 1} .carousel-item-${numberOfItems - 1}`
        );
        if (last) {
          current?.parentElement.insertBefore(last.cloneNode(true), current);
        }
      }

      if (next?.firstElementChild) {
        current?.parentElement.appendChild(next.cloneNode(true));
      } else {
        let first = document.querySelector(`#carousel-item-0 .carousel-item-0`);
        if (first) {
          current?.parentElement.appendChild(first.cloneNode(true));
        }
      }
    }
  });
</script>

<div id="carousel-item-{index}">
  <div class="carousel-item mt-4 {index === 0 ? 'active' : ''}">
    <div class="item__third carousel-item-{index}">
      <slot></slot>
    </div>
  </div>
</div>

<style>
  .carousel-item {
    height: 490px;
  }

  .item__third:first-child,
  .item__third:last-child {
    display: none;
  }

  .carousel-item-next:not(.carousel-item-start),
  .carousel-item-end.active {
    -webkit-transform: translate3d(33%, 0, 0);
    transform: translate3d(33%, 0, 0);
  }

  .carousel-item-prev:not(.carousel-item-end),
  .carousel-item-start.active {
    -webkit-transform: translate3d(-33%, 0, 0);
    transform: translate3d(-33%, 0, 0);
  }

  @media (min-width: 1000px) {
    .item__third {
      display: block !important;
      position: relative;
      width: 33.33333333%;
      height: 100%;
      padding-left: 10px;
      padding-right: 10px;
      float: left;
    }
  }
</style>
